import { Routes } from '@angular/router';
import { convertStoryblokCustomRatingsResolver } from '../../storyblok/convert-storyblok-custom-ratings.resolver';
import { storyblokFooterResolver } from '../../storyblok/storyblok-footer.resolver';
import { storyblokHeaderResolver } from '../../storyblok/storyblok-header.resolver';
import { convertFormatsResolver } from './convert-formats.resolver';
import { convertStoryblokRelationshipsResolver } from './convert-relationships.resolver';
import { convertStoryblokStoryResolver } from './convert-story.resolver';
import { ConversionTemplateComponent } from './templates/conversion-template/conversion-template.component';

export const routes: Routes = [
  {
    path: '',
    resolve: {
      story: convertStoryblokStoryResolver,
      relationships: convertStoryblokRelationshipsResolver,
      formats: convertFormatsResolver,
      customRatings: convertStoryblokCustomRatingsResolver,
      footer: storyblokFooterResolver,
      header: storyblokHeaderResolver,
    },
    component: ConversionTemplateComponent,
  },
];
